import type {SxProps, Theme} from "@mui/material";

/** The round 36px action button at the composer's top-right corner: Send, or Stop while the agent works. */
export const composerButtonSx: SxProps<Theme> = {
    position: "absolute",
    right: "16px",
    top: "16px",
    backgroundColor: "info.main",
    color: "#fff",
    "&:hover": {
        backgroundColor: "info.dark",
    },
};
